export default __webpack_public_path__ + "static/media/h_4.c900c77c.jpg";